import React from "react";
import UIBaseComponent from "UIComponents/UIBaseComponent";
import I18nHOC from "UIComponents/I18nHOC";
import PropTypes from "prop-types";
import { compose } from "lib/apolloClient";
import { connect } from "react-redux";
import classNames from "classnames";
import classes from "./TextFieldInput.scss";

class TextFieldInput extends UIBaseComponent {
  constructor(props) {
    super(props);
    const { value } = props;
    const initialValue =
      value === undefined || value === null ? "" : value.toString();

    this.state = {
      isFocused: false,
      inputValue: initialValue,
    };
  }

  componentDidUpdate(prevProps) {
    // Update state if props value changes externally
    if (prevProps.value !== this.props.value) {
      const { value } = this.props;
      const newValue =
        value === undefined || value === null ? "" : value.toString();
      this.setState({ inputValue: newValue });
    }
  }

  handleInputFocus = () => {
    this.setState({ isFocused: true });
  };

  handleInputChange = event => {
    const value = event.target.value;
    this.setState({ inputValue: value }, () => {
      this.updateValue(this.state.inputValue);
    });
  };

  handleInputBlur = () => {
    this.setState({ isFocused: false });
  };

  getValue = () => {
    return this.state.inputValue;
  };

  renderTextInput = () => {
    const { disabled = false, testId, t, placeholder } = this.props;
    const value = this.getValue();

    const inputClassName = classNames(classes.textInput, "text-body");

    return (
      <div className={classNames(classes.container, "text-body")}>
        <input
          type="text"
          className={inputClassName}
          value={value}
          placeholder={placeholder || t("common:enter_text")}
          onFocus={this.handleInputFocus}
          onChange={this.handleInputChange}
          onBlur={this.handleInputBlur}
          disabled={disabled}
          data-testid={testId}
          ref={ref => {
            this.inputRef = ref;
          }}
        />
      </div>
    );
  };

  renderViewValue = () => {
    const { t } = this.props;
    const value = this.getValue();

    return value ? (
      <div className={classNames(classes.viewContainer, "text-body")}>
        {value}
      </div>
    ) : (
      <div className={classNames(classes.placeholder, "text-body")}>
        {t("common:not_selected")}
      </div>
    );
  };

  renderEdit = () => this.renderTextInput();
  renderView = () => this.renderViewValue();
}

const mapStateToProps = (state, ownProps) => {
  const { mode, disabled = false } = ownProps;

  return {
    disabled: disabled || mode === "view",
  };
};

TextFieldInput.defaultProps = {
  ...UIBaseComponent.defaultProps,
  overlayStyle: {},
  testId: "UIComponents-TextFieldInput",
  placeholder: "",
};

TextFieldInput.propTypes = {
  ...UIBaseComponent.propTypes,
  overlayStyle: PropTypes.object,
  testId: PropTypes.string,
  placeholder: PropTypes.string,
};

export default compose(
  I18nHOC({ resource: ["common"] }),
  connect(mapStateToProps, null)
)(TextFieldInput);
